import React, { useState, useEffect } from 'react';
import { List } from 'lucide-react';

const TableOfContents = ({ headings }) => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0.1 }
    );

    headings.forEach(h => {
      const el = document.getElementById(h.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [headings]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -100;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  // Only show H2 and H3
  const tocItems = headings.filter(h => h.level === 2 || h.level === 3);

  if (tocItems.length === 0) return null;

  return (
    <nav className="bg-white border border-slate-200 rounded-xl p-5" data-testid="table-of-contents">
      <div className="flex items-center gap-2 mb-4">
        <List className="h-4 w-4 text-[#115E59]" />
        <span className="text-xs font-bold text-slate-900 uppercase tracking-wider">Contents</span>
      </div>
      <ul className="space-y-1">
        {tocItems.map((h, i) => (
          <li key={i}>
            <button
              onClick={() => scrollTo(h.id)}
              className={`block text-left w-full text-xs leading-relaxed py-1 transition-colors ${
                h.level === 3 ? 'pl-4' : ''
              } ${
                activeId === h.id
                  ? 'text-[#115E59] font-semibold'
                  : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              {h.text}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TableOfContents;
